import type { WidgetEnvironment, WidgetEnvironmentExtended } from '../../../common/sgwt-widgets-utils';

export const SPLASH_SCREEN_ENDPOINTS: Record<WidgetEnvironmentExtended, Record<'api' | 'feedback', string>> = {
  development: {
    api: 'https://sgwt-api-sgwt-splash-screen-dev.sgmarkets.world.socgen/api/v1',
    feedback: 'https://sgwt-api-sgwt-help-center-dev.sgmarkets.world.socgen/api/v1/feedback',
  },
  internal_homologation: {
    api: 'https://sgwt-api-sgwt-splash-screen-uat.sgmarkets.world.socgen/api/v1',
    feedback: 'https://sgwt-api-sgwt-help-center-uat.sgmarkets.world.socgen/api/v1/feedback',
  },
  homologation: {
    api: 'https://api-s-uat.sgmarkets.com/widget/webtoolkit/splash-screen/v1',
    feedback: 'https://api-s-uat.sgmarkets.com/widget/webtoolkit/help-center/v1/feedback',
  },
  internal_production: {
    api: 'https://sgwt-api-sgwt-splash-screen.sgmarkets.world.socgen/api/v1',
    feedback: 'https://sgwt-api-sgwt-help-center.sgmarkets.world.socgen/api/v1/feedback',
  },
  production: {
    api: 'https://api-s.sgmarkets.com/widget/webtoolkit/splash-screen/v1',
    feedback: 'https://api-s.sgmarkets.com/widget/webtoolkit/help-center/v1/feedback',
  },
};

type DisclaimerEndpoint = 'api' | 'page' | 'restrictedCountry';

export const DISCLAIMER_ENDPOINTS: Record<WidgetEnvironment, Record<DisclaimerEndpoint, string>> = {
  development: {
    api: 'https://api-z-dev.sgmarkets.com/uat/sgm/serviceboard/v2/api/v2/userdisclaimers?application=',
    page: 'https://www-uat.sgmarkets.com/disclaimer/page',
    restrictedCountry: 'https://www-uat.sgmarkets.com/disclaimer/countryrestricted',
  },
  homologation: {
    api: 'https://api-z-dev.sgmarkets.com/uat/sgm/serviceboard/v2/api/v2/userdisclaimers?application=',
    page: 'https://www-uat.sgmarkets.com/disclaimer/page',
    restrictedCountry: 'https://www-uat.sgmarkets.com/disclaimer/countryrestricted',
  },
  production: {
    api: 'https://api-z.sgmarkets.com/sgm/serviceboard/v2/api/v2/userdisclaimers?application=',
    page: 'https://www.sgmarkets.com/disclaimer/page',
    restrictedCountry: 'https://www.sgmarkets.com/disclaimer/countryrestricted',
  },
};

export interface ISplashScreenDisclaimerInfo {
  api: string;
  page: string;
  restrictedCountry: string;
}

export interface ISplashScreenEnvEndpoints {
  api: string;
  disclaimer: ISplashScreenDisclaimerInfo;
  feedback: string;
}

export interface ISplashScreenEndpoints {
  development: ISplashScreenEnvEndpoints;
  homologation: ISplashScreenEnvEndpoints;
  production: ISplashScreenEnvEndpoints;
}
